<template>
  <b-nav is-nav-bar class="lang-user-wrapper text-center">    
    <b-nav-item-dropdown :text="this.$i18n.locale()==='en'?'English':this.$i18n.locale()==='hi'?'हिन्दी':'मराठी'" class="lang-wrapper">
      <b-dropdown-item id="chnglangbtn1" name="chnglangbtn1name" :class="{onn: this.$i18n.locale()==='en'?true:false}" @click="changelang('en')">English</b-dropdown-item>
      <b-dropdown-item id="chnglangbtn2" name="chnglangbtn2name" :class="{onn: this.$i18n.locale()==='hi'?true:false}" @click="changelang('hi')">हिन्दी</b-dropdown-item>
      <b-dropdown-item id="chnglangbtn3" name="chnglangbtn3name" :class="{onn: this.$i18n.locale()==='mr'?true:false}" @click="changelang('mr')">मराठी</b-dropdown-item>
    </b-nav-item-dropdown>
  </b-nav>
</template>

<script>
// import axios from 'axios'
// import { mixin as onClickOutside } from 'vue-on-click-outside'

export default {
  name: 'language',
  // mixins: [onClickOutside],
  components: {
  },
  data () {
    return {
    }
  },
  methods: {
    changelang (opt) {
      this.$i18n.set(opt)
    }
  },
  created: function () {
    this.changelang(this.$store.state.login.user.langPref)
  }
}
</script>
<style lang="scss">
.lang-wrapper{
  width: auto;
  display: inline-block;
  margin: 0 auto;
  
    .nav-link {
        /*padding-left: 0; padding-right: 0;*/
        border: none;
        border-radius: 2px;
        color: #78909c;
        padding: 5px;    
    }
   
    .dropdown-menu {
        padding-top: 5px;
        padding-bottom: 5px;
        font-size: 13px;
        border: none;
        box-shadow: 3px 3px 7px 2px rgba(0, 0, 0, 0.16), 0 0px 0px 0 rgba(0, 0, 0, 0.12);
        .dropdown-item {
            padding: 1px 18px;
            &.onn {
              color: #fff;
                background: #607D8B;
            }
        }
    }
}
</style>




// WEBPACK FOOTER //
// src/components/common/language.vue